module.exports = __webpack_public_path__ + "static/media/ylt_orig_scaled_grayscale-compressor.c091fb08.jpg";